export const ACCESS_ROUTES = {
  appointments: 'appointments',
  services: 'services',
  categories: 'categories',
  clients: 'clients',
  manage_schedule: 'manage_schedule',
  manage_subscription: 'manage_subscription',
};
